export default "__VITE_ASSET__BxERuFLN__"